<template>
    <footer class="footer">
        <div class="footer__container -wrap">
            <Logo class="footer__logo" type="footer-logo"/>
        </div>
        <div class="footer__container -wrap">
            <ul class="footer__list">
                <li class="footer__line -title" v-html="$t('Footer.eduhouse')"></li>
                <li class="footer__line -address" v-html="addressLine"></li>
                <li class="footer__line " v-html="$t('Footer.row1_label')"></li>

                <FooterLink :url="$t('Footer.contact_us_url')" :label="$t('Footer.contact_us')" icon="contact" />
                <FooterLink :url="$t('Footer.phone_number')" :label="$t('Footer.phone_number')" icon="phone" />
                <template v-if="!isLoggedIn">
                    <FooterLink :url="$t('FooterGoLearn.business_url')" :label="$t('FooterGoLearn.business')" />
                    <FooterLink :url="$t('FooterGoLearn.how_online_course_works_url')" :label="$t('FooterGoLearn.how_online_course_works')" />
                    <FooterLink :url="$t('FooterGoLearn.about_us_url')" :label="$t('FooterGoLearn.about_us')" />
                    <FooterLink :url="$t('FooterGoLearn.become_instructor_url')" :label="$t('FooterGoLearn.become_instructor')" />
                </template>
                <div class="footer__language-container">
                    <span class="footer__language-text" v-html="$t('Footer.interface_language')"></span>
                    <SelectLanguage />
                </div>
            </ul>

            <template v-if="!isLoggedIn">
                <ul class="footer__list --categories">
                    <li class="footer__line -title" v-html="$t('Footer.categories')"></li>
                    <li
                        class="footer__line -categories-item"
                        v-for="subjectArea in subjectAreas"
                        @click="goToSubjectArea(subjectArea)"
                        :key="subjectArea.code"
                        :data-text="subjectArea.label"
                    >
                        {{ subjectArea.label }}
                    </li>
                </ul>
            </template>

            <ul class="footer__list --support">
                <li class="footer__line -title" v-html="$t('Footer.customer_support')"></li>
                <li class="footer__line" v-html="$t('Footer.open_hours')"></li>
                <FooterLink :url="$t('Footer.contact_us_url')" :label="$t('Footer.contact_us')" icon="contact" />
                <FooterLink :url="$t('Footer.email')" :label="$t('Footer.email')" icon="email" />
                <FooterLink :url="$t('Footer.phone_number')" :label="$t('Footer.phone_number')" icon="phone" />
                <FooterLink :url="$t('Footer.faq_url')" :label="$t('Footer.faq')" icon="faq" />
            </ul>
            <template v-if="!isLoggedIn">
                <div class="footer__list">
                    <ul class="footer__list -privacy">
                        <li class="footer__line -title" v-html="$t('Footer.privacy_and_terms')"></li>
                        <FooterLink :url="$t('Footer.row3_url')" :label="$t('Footer.row3_label')" />
                        <FooterLink :url="$t('Footer.row4_url')" :label="$t('Footer.row4_label')" />
                        <li class="footer__line">
                            <router-link :to="{ name: 'accessibility-form' }">{{ $t('Footer.accessibilityStatement_label') }}</router-link>
                        </li>
                        <a class="footer__consent-button" href="javascript: Cookiebot.show()" v-html="$t('Footer.cookies')"></a>
                    </ul>
                    <ul class="footer__list -socials">
                        <FooterSocials class="footer__socials" />
                        <FooterLink :url="'https://' + $t('StoreMenu.home')" :label="$t('StoreMenu.home')" class="footer__homepage" />
                        <TotemRouterLink
                            size="medium"
                            color="secondary"
                            :to="trialFormRoute"
                            :label="$t('HeroGoLearn.try_for_free')"
                        />
                    </ul>
                </div>
            </template>
            <template v-else>
                <ul class="footer__list -privacy">
                        <li class="footer__line -title" v-html="$t('Footer.privacy_and_terms')"></li>
                        <FooterLink :url="$t('Footer.row3_url')" :label="$t('Footer.row3_label')" />
                        <FooterLink :url="$t('Footer.row4_url')" :label="$t('Footer.row4_label')" />
                        <li class="footer__line">
                            <router-link :to="{ name: 'accessibility-form'}">{{ $t('Footer.accessibilityStatement_label') }}</router-link>
                        </li>
                        <a class="footer__consent-button" href="javascript: Cookiebot.show()" v-html="$t('Footer.cookies')"></a>
                </ul>
                <ul class="footer__list -socials">
                    <FooterSocials class="footer__socials" />
                    <FooterLink :url="'https://' + $t('StoreMenu.home')" :label="$t('StoreMenu.home')" class="footer__homepage" />
                </ul>
            </template>
        </div>
    </footer>
</template>

<script>
    import FooterLink from 'components/layout/footer/footer-link'
    import FooterSocials from 'components/layout/footer/footer-socials'
    import FooterHubspotChat from 'components/layout/footer/footer-hubspot-chat'
    import Logo from 'components/layout/Logo'
    import { mapGetters } from 'vuex'
    import subjectAreaNavigationHelper from 'components/layout/mixins/subjectAreaNavigationHelper'
    import { getTrialFormRoute } from '@/routes'
    import SelectLanguage from 'components/layout/SelectLanguage'

    export default {
        name: 'footer-go-learn',
        components: {
            Logo,
            FooterSocials,
            FooterLink,
            FooterHubspotChat,
            SelectLanguage
        },
        data () {
            return {
                trialFormRoute: getTrialFormRoute()
            }
        },
        mixins: [subjectAreaNavigationHelper],
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                showFooterSubscribe: 'User/getShowFooterSubscribe',
                categories: 'Menu/getCategories'
            }),
            subjectAreas () {
                return this.categories.map(el => ({
                    label: el.translatedName,
                    code: el.slug,
                    customerSpecific: el.customerSpecific
                }))
            },
            addressLine () {
                return this.$t('Footer.address_line_1') + ', ' + this.$t('Footer.address_line_2')
            },
            isTabletAndMobileView () {
                return this.$mq.includes('mobile_sm') || this.$mq.includes('mobile_md') || this.$mq.includes('desktop_l') || this.$mq.includes('desktop_xl')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @include footer;
</style>
